import React, { useRef, useState, useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import MainActionsHeader from '../../components/mainActions';
import Sidebar from '../../components/sidebar';
import MainFooter from '../../components/footer';
import MainModal from '../../components/modal';
import { useAuth } from "../../state/auth";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { authTokens } = useAuth();
  const reloadFun = useRef();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [sidebarClosed, setSidebarClosed] = useState(window.innerWidth <= 768);
  const [hovered, updateHovered] = useState(false);

  const [state, setState] = useState({
    modalVisible: false,
    modalVariant: null,
    recordId: null,
    extraData: null
  });

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      
      if (mobile) {
        setSidebarClosed(true);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const openMainModal = (modalVariant, recordId, reload, extraData) => {
    reloadFun.current = reload;
    setState({ modalVisible: true, modalVariant, recordId, extraData });
  };

  const closeMainModal = () => {
    setState({ modalVisible: false, modalVariant: null, recordId: null, extraData: null });
  };

  return (
    <Route {...rest}
      render={props => (
        authTokens ? (
          <div style={{ display: 'flex', minHeight: '100vh', width: '100%' }}>
            <div style={{ 
              width: isMobile ? '0px' : (!sidebarClosed || hovered ? '220px' : '80px'),
              transition: 'width 0.3s ease',
              flexShrink: 0 
            }}>
              <Sidebar 
                hovered={hovered} 
                updateHovered={updateHovered}
                isMobile={isMobile}
                sidebarClosed={sidebarClosed}
                setSidebarClosed={setSidebarClosed}
              />
            </div>

            <div style={{ 
              flex: 1, 
              display: 'flex', 
              flexDirection: 'column',
              minWidth: 0,
              backgroundColor: '#f8f9fa'
            }}>
              <MainActionsHeader 
                openMainModal={openMainModal} 
                toggleSidebar={() => setSidebarClosed(!sidebarClosed)} 
              />
              
              <div style={{ flex: 1}}>
                <Component {...props} 
                  openMainModal={openMainModal} 
                  closeMainModal={closeMainModal} 
                />
              </div>
              <MainFooter />
            </div>

            <MainModal
              modalVisible={state.modalVisible}
              modalVariant={state.modalVariant}
              recordId={state.recordId}
              closeMainModal={closeMainModal}
              openMainModal={openMainModal}
              reload={reloadFun.current}
              extraData={state.extraData}
            />
          </div>
        ) : (
          <Redirect to={{ pathname: "/", state: { from: props.location } }} />
        )
      )}
    />
  );
};

export default PrivateRoute;